import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { c } from 'ttag';
import Icon from '../Icon/Icon';
const LastEditedByBadge = ({ contact }) => {
    return (_jsxs("div", { title: c('B2.NavSharedUI.Label').t `Last edited by`, className: "flex select-none items-center rounded bg-info px-1.5 py-1 text-info-contrast", children: [_jsx(Icon, { ariaLabel: c('B2.NavSharedUI.Label').t `Shared by`, type: "pencil", className: "mr-1 text-info-contrast", size: "medium" }), _jsx("span", { className: "mr-auto overflow-hidden text-ellipsis text-sm font-semibold lg:text-xs", children: contact.name })] }));
};
export default LastEditedByBadge;
